import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Auth } from '@core/services';
import { Sidebar, Title } from '@shared/services';
import { UserRole } from '@core/interfaces/role.interface';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss'
})
export class Navbar {
  private authService = inject(Auth);
  sidebarService = inject(Sidebar);
  titleService = inject(Title);

  user = computed(() => this.authService.user || {});

  firstName = computed(() => this.user().firstName || '');
  lastName = computed(() => this.user().lastName || '');
  userInitials = computed(() => {
    const f = this.firstName();
    const l = this.lastName();
    return f && l ? `${f[0]}${l[0]}`.toUpperCase() : '??';
  });
  userName = computed(() => `${this.firstName()} ${this.lastName()}`);
  userEmail = computed(() => this.user().email || '');
  isAdmin = computed(() => this.user().role?.name === UserRole.ADMIN);
  creditLimit = computed(() => this.user().eSimCreditLimit || 0);
}
